export const CHART_COLORS = {
  // Estatus de lotes
  DISPONIBLE: '#2196F3',
  APARTADO: '#FF9800',
  CREDITOACTIVO: '#4CAF50',
  LIQUIDADO: '#9E9E9E',
  PENDIENTE: '#F44336',
  // Métodos de pago
  EFECTIVO: '#4CAF50',
  TARJETA: '#2196F3',
  TRANSFERENCIA: '#FF9800',
  // Moratorios
  MORATORIO: '#F44336',
  // Tendencia
  TENDENCIA: '#7C4DFF',
};
